import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { CenteredFullScreenLayout } from "@/components/layout"
import { useAuth } from '@/contexts'
import { supabase } from '@/lib/supabase'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { toast } from 'sonner'

export default function UpdatePasswordPage() {
  const { updatePassword } = useAuth()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isExchanging, setIsExchanging] = useState(true)

  useEffect(() => {
    const exchange = async () => {
      const url = new URL(window.location.href)
      const code = url.searchParams.get('code')

      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code)
        if (error) {
          toast.error('Invalid or expired reset link. Please request a new one.')
          window.history.replaceState(null, '', '/update-password')
        }
      }
      setIsExchanging(false)
    }

    exchange()
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      toast.error('Passwords do not match')
      return
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters')
      return
    }

    setIsLoading(true)

    const { error } = await updatePassword(password)

    if (error) {
      toast.error(error.message)
      setIsLoading(false)
      return
    }

    toast.success('Password updated successfully!')
    navigate('/home')
  }

  if (isExchanging) {
    return (
      <CenteredFullScreenLayout>
        <div className="w-full max-w-sm mx-4 p-6 bg-card rounded-lg shadow-lg text-center">
          <p className="text-muted-foreground">Verifying reset link...</p>
        </div>
      </CenteredFullScreenLayout>
    )
  }

  return (
    <CenteredFullScreenLayout>
      <div className="w-full max-w-sm mx-4 p-6 bg-card rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-6">Set New Password</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">New Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="confirmPassword">Confirm New Password</Label>
            <Input
              id="confirmPassword"
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>

          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? 'Updating...' : 'Update Password'}
          </Button>
        </form>
      </div>
    </CenteredFullScreenLayout>
  )
}
